// extracted by mini-css-extract-plugin
export var Difference = "Difference-module--Difference--d3b7c";
export var DifferenceCorrect = "Difference-module--Difference--correct--3206e";
export var DifferenceCorrectImage = "Difference-module--Difference--correctImage--7ed30";
export var DifferenceIncorrect = "Difference-module--Difference--incorrect--10df4";
export var DifferenceIncorrectImage = "Difference-module--Difference--incorrectImage--18b83";